import React, { useEffect } from "react";
import Stats from "./Stats";
import { Grid } from "@material-ui/core";

import { green } from "@material-ui/core/colors";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { getPeriodicSales } from "../../redux/actions/salesActions";

// helpers
import { formatCurrency } from "../../utils/helpers";

const TotalSales = ({ period }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    getPeriodicSales(dispatch, period);
  }, [dispatch, period]);

  const {
    totalSalesSummary: { loading, sales },
  } = useSelector((state) => state.sales);
  return (
    <Grid item xs={12} sm={12} md={6} lg={3} xl>
      <Stats
        title="Total Sales"
        loading={loading}
        data={`${formatCurrency("KES", sales)}`}
        amount="24,000,000"
        chip="Overall"
        percentageText="+18%"
        percentagecolor={green[500]}
      />
    </Grid>
  );
};

export default TotalSales;
